// extracted by mini-css-extract-plugin
module.exports = {"Search_Result_Top_Section":"SearchResultTopSection_Search_Result_Top_Section__NHWO6"};